module.exports = __webpack_public_path__ + "static/media/8900_Kitchen.be504cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Kitchen.jpg
// module id = 578
// module chunks = 0